module.exports = __webpack_public_path__ + "img/keji.4b4ee675.jpeg";